import type { ValueFormatterParams } from "ag-grid-community";

import { useFormatMoney } from "~/modules/multi-currency/ui/format-money";

import { formatReportDollarAmount } from "../utils/report-money";

export const DollarCurrencyCellRenderer = (params: ValueFormatterParams<number>) => {
  const raw = params.value as number | undefined;
  const formatMoney = useFormatMoney();
  return formatReportDollarAmount(raw, formatMoney, 2);
};
